import styled from 'styled-components';
import { Box, Paper } from '@mui/material';

export const MaintenanceWrapper = styled(Box)`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f7f6;
  padding: 20px;
`;

export const ContentCard = styled(Paper)`
  && {
    padding: 48px;
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.05);
  }
`;

export const IconWrapper = styled(Box)`
  color: #0057ff;
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-start;
`;

export const ContactSection = styled(Box)`
  background-color: #fff;
  border-left: 4px solid #0057ff;
  padding: 24px;
  border-radius: 0 16px 16px 0;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.02);
`;
